import { FleekError } from './FleekError';

export class UploadedS3KeyNotFoundError extends FleekError<Record<string, never>> {
  public name = 'UploadedS3KeyNotFoundError';

  toString = () => 'Uploaded S3 Key not found.';
}
